/* eslint-disable react/prop-types */
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";

/**
 * Reusable stat tile used across the three dashboards.
 * Visual: white card · icon top-left in a soft pastel tile · big number
 * · label below · optional delta line.
 *
 *   <StatTile icon="people" label="Members" value="1,248" delta="+12 this week" tone="success" />
 */
export default function StatTile({ icon, label, value, sub, tone = "primary" }) {
  const theme = useTheme();
  const toneMap = {
    primary: { bg: theme.palette.teal[50], fg: theme.palette.teal[700] },
    info: { bg: "#E0F2FE", fg: "#0369A1" },
    warning: { bg: "#FEF3C7", fg: "#B45309" },
    success: { bg: "#DCFCE7", fg: "#15803D" },
    danger: { bg: "#FEE2E2", fg: "#B91C1C" },
    purple: { bg: "#EDE9FE", fg: "#6D28D9" },
  };
  const t = toneMap[tone] || toneMap.primary;

  return (
    <Card sx={{ p: 2.5, height: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2.25,
            bgcolor: t.bg,
            color: t.fg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <Icon sx={{ fontSize: 22 }}>{icon}</Icon>
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
            {label}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: 24, md: 28 },
              fontWeight: 800,
              lineHeight: 1.1,
              mt: 0.25,
              letterSpacing: "-0.02em",
            }}
          >
            {value}
          </Typography>
          {sub && (
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
              {sub}
            </Typography>
          )}
        </Box>
      </Box>
    </Card>
  );
}
